module.exports = __webpack_public_path__ + "img/bars.0863f8dc.svg";